import { useSelector } from "react-redux";
import { useTheme, useMediaQuery, Box } from "@mui/material";
import MyPostWidget from "scenes/widgets/MyPostWidget";
import PostsWidget from "scenes/widgets/PostsWidget";
import AdvertWidget from "scenes/widgets/AdvertWidget";
import FriendListWidget from "scenes/widgets/FriendListWidget";
import UserWidget from "scenes/widgets/UserWidget";
import useAuthCheck from "hooks/useAuthCheck";


const Posts = () => {
  useAuthCheck();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const { _id, picturePath } = useSelector((state) => state.user);

  return (
    <Box
      display={isDesktop ? "flex" : "block"}
      justifyContent="space-between"
      padding="1rem"
      gap={1.5}
    >
      {/* Left sidebar */}
      {isDesktop && (
        <Box flexBasis="24%" sx={{ position: "sticky", top: "1rem", alignSelf: "flex-start" }}>
          <UserWidget userId={_id} picturePath={picturePath} />
        </Box>
      )}

      {/* Center feed */}
      <Box
        flexBasis={isDesktop ? "50%" : undefined}
        mt={isDesktop ? undefined : "1rem"}
      >
        <MyPostWidget picturePath={picturePath} />
        <PostsWidget userId={_id} />
      </Box>

      {/* Right sidebar */}
      {isDesktop && (
        <Box flexBasis="24%">
          <AdvertWidget />
          <Box mt={2} />
          <FriendListWidget userId={_id} />
        </Box>
      )}
    </Box>
  );
};

export default Posts;
